import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/multicolor_sedna_world_logo.svg")